<div class="filter-range">
  <ng-container *ngIf="isLoading; then loader; else rangeInputs"></ng-container>
</div>
<ng-template #loader>
  <div class="filter-placeholder filter-placeholder-range">
    <div class="range-start-placeholder"></div>
    <span class="range-separator">&mdash;</span>
    <div class="range-end-placeholder"></div>
  </div>
</ng-template>
<ng-template #rangeInputs>
  <div class="field-group range-inputs">
    <input
      data-test="filter-library-range-numeric-min"
      type="number"
      class="form-control form-control-sm"
      placeholder="{{ dataMin }}"
      [ngModel]="filterMin"
      (ngModelChange)="onMinChange($event)"
      (blur)="onBlurInput()"
    />
    <span class="range-separator">&mdash;</span>
    <input
      data-test="filter-library-range-numeric-max"
      type="number"
      class="form-control form-control-sm"
      placeholder="{{ dataMax }}"
      [ngModel]="filterMax"
      (ngModelChange)="onMaxChange($event)"
      (blur)="onBlurInput()"
    />
  </div>
</ng-template>